<div class="associations-container dark-mode">
    <div class="page-header mt-5">
        <h1 class="page-title">Certifications</h1>
        <div class="breadcrumb">
            <span class="breadcrumb-item">Dashboard</span>
            <span class="breadcrumb-separator mx-2">/</span>
            <span class="breadcrumb-current">Certifications</span>
        </div>
    </div>

    <hr class="mb-3" />

    <div class="row">
        <div class="col-6 col-sm-6 col-md-6 text-end">
            <div class="d-flex" style="gap: 10px">
                <mat-form-field class="w-100" appearance="outline" >
                    <mat-icon style="font-size: 20px;" matPrefix>search</mat-icon>
                    <input type="text" placeholder="Search" matInput [(ngModel)]="pageQuery.search" (keyup)="searchUser($event)">
                    <mat-icon (click)="clearSearch()" *ngIf="showCloseSearch && pageQuery.search.length > 0" class="button-flat" matSuffix>close</mat-icon>
                </mat-form-field>
                <button class="add-new-button" (click)="addNewCertification()" mat-raised-button >
                    <mat-icon>add</mat-icon>
                    Add New
                </button>
            </div>

        </div>
    </div>

    <div class="table-responsive-dark list-wrapper-bordered-dark">
        <table class="table table-striped table-hover table-bordered ">
            <thead>
            <tr>
                <th class="text-nowrap">ID</th>
                <th class="text-nowrap">Certification Title</th>
                <th class="text-nowrap">Provider</th>
                <th class="text-nowrap">Attendance Type</th>
                <th class="sticky-action"></th>
            </tr>
            </thead>
            <tbody>
            <ng-container *ngIf="certifications.length > 0">
                <tr *ngFor="let cert of certifications">
                    <td class="text-start">
                        {{cert.id}}
                    </td>
                    <td class="text-start">
                        {{cert.certificationTitle}}
                    </td>
                    <td class="text-start">
                        {{cert.association.providerName}}
                    </td>
                    <td class="text-start">
                        {{mergeAttendanceTypes(cert.attendanceTypes)}}
                    </td>
                    <td class="text-center action-column" style="width: 80px">
                        <div class="d-flex gap-2 justify-content-center">
                            <mat-icon class="text-white" style="margin-left: -5px" (click)="detailCertification(cert.id)">arrow_forward</mat-icon>
                            <mat-icon class="crimson-red" (click)="deleteCertification(cert.id)">delete</mat-icon>
                        </div>
                    </td>
                </tr>
            </ng-container>

            <tr *ngIf="certifications.length == 0">
                <td colspan="5" class="text-center">
                    <span>{{tableLoading ? 'Load data...' : 'No Record'}}</span>
                </td>
            </tr>
            </tbody>
        </table>
    </div>
    <div *ngIf="certifications.length > 0">
        <app-pagination-dark
                (goPage)="toPage($event)"
                (goPerPage)="perPageSet($event)"
                [pagesToShow]="showPages"
                [page]="pageNo"
                [perPage]="pageSize"
                [count]="totalRow"></app-pagination-dark>
    </div>
</div>
